import { TypePolicy } from '@apollo/client';

const sharedTypePolicies: Dict<TypePolicy> = {
  Query: {
    fields: {
      viewer: {
        merge(existing = [], incoming: any) {
          return { ...existing, ...incoming };
        },
      },
    },
  },
  Product: {
    keyFields: false,
    merge: true,
    fields: {
      variants: {
        read(variants, { readField }) {
          const filteredVariants =
            variants &&
            variants.filter((variant) => !readField('hidden', variant));

          return filteredVariants;
        },
      },
    },
  },
  Variant: {
    keyFields: false,
  },
  Market: {
    merge: true,
  },
  BidAskData: {
    merge: true,
  },
  Media: {
    merge: true,
  },
};

export default sharedTypePolicies;
